const localeSettingsMap: Partial<Record<server.dto.LCID, server.dto.CulturePageOptions>> = {
  "english_US": {
    firstDayOfWeek: 0,
    is24Hr: false,
    unitOfDistance: "imperial",
    numberDecimalSeparator: ".",
    numberGroupSeparator: ",",
    timeSeparator: ":",
    uiLanguage: "en",
    uiLocale: "en-US"
  },
  "english_GB": {
    firstDayOfWeek: 1,
    is24Hr: true,
    unitOfDistance: "metric",
    numberDecimalSeparator: ".",
    numberGroupSeparator: ",",
    timeSeparator: ":",
    uiLanguage: "en",
    uiLocale: "en-GB"
  },
  "english_IE": {
    firstDayOfWeek: 1,
    is24Hr: false,
    unitOfDistance: "metric",
    numberDecimalSeparator: ".",
    numberGroupSeparator: ",",
    timeSeparator: ":",
    uiLanguage: "en",
    uiLocale: "en-IE"
  },
  "dutch_NL": {
    firstDayOfWeek: 1,
    is24Hr: true,
    unitOfDistance: "metric",
    numberDecimalSeparator: ",",
    numberGroupSeparator: ".",
    timeSeparator: ":",
    uiLanguage: "nl",
    uiLocale: "nl-NL"
  },
  "dutch_BE": {
    firstDayOfWeek: 1,
    is24Hr: true,
    unitOfDistance: "metric",
    numberDecimalSeparator: ",",
    numberGroupSeparator: ".",
    timeSeparator: ":",
    uiLanguage: "nl",
    uiLocale: "nl-BE"
  },
  "german_DE": {
    firstDayOfWeek: 1,
    is24Hr: true,
    unitOfDistance: "metric",
    numberDecimalSeparator: ",",
    numberGroupSeparator: ".",
    timeSeparator: ":",
    uiLanguage: "de",
    uiLocale: "de-DE"
  },
  "spanish": {
    firstDayOfWeek: 1,
    is24Hr: true,
    unitOfDistance: "metric",
    numberDecimalSeparator: ",",
    numberGroupSeparator: ".",
    timeSeparator: ":",
    uiLanguage: "es",
    uiLocale: "es-ES"
  },
  "portuguese_BR": {
    firstDayOfWeek: 0,
    is24Hr: true,
    unitOfDistance: "metric",
    numberDecimalSeparator: ",",
    numberGroupSeparator: ".",
    timeSeparator: ":",
    uiLanguage: "pt",
    uiLocale: "pt-BR"
  },
  "portuguese_PT": {
    firstDayOfWeek: 1,
    is24Hr: true,
    unitOfDistance: "metric",
    numberDecimalSeparator: ",",
    numberGroupSeparator: ".",
    timeSeparator: ":",
    uiLanguage: "pt",
    uiLocale: "pt-PT"
  },
  "italian": {
    firstDayOfWeek: 1,
    is24Hr: true,
    unitOfDistance: "metric",
    numberDecimalSeparator: ",",
    numberGroupSeparator: ".",
    timeSeparator: ":",
    uiLanguage: "it",
    uiLocale: "it-IT"
  }
};

const viewModel = (window as any).viewModel as any;

if (typeof viewModel.webformId === "number" && typeof viewModel.culture === "string") {
  site.culture = localeSettingsMap[viewModel.culture] ?? localeSettingsMap["english_GB"];
}